document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.dropdown__btn');
  const menu = document.querySelector('.dropdown__menu');
  const menuLinks = document.querySelectorAll(
    '.dropdown__menu .navmenu__list a'
  );

  if (btn && menu) {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      btn.classList.toggle('is-open');
      menu.classList.toggle('is-open');
    });

    menuLinks.forEach(link => {
      link.addEventListener('click', () => {
        btn.classList.remove('is-open');
        menu.classList.remove('is-open');
      });
    });

    document.addEventListener('click', e => {
      if (
        menu.classList.contains('is-open') &&
        !menu.contains(e.target) &&
        !btn.contains(e.target)
      ) {
        btn.classList.remove('is-open');
        menu.classList.remove('is-open');
      }
    });
  }
});
